export default "__VITE_ASSET__CF9S8Dj4__"